import React from 'react';
import {Link} from "react-router-dom";
import {Menu} from '../Header/menu';
import {Sale} from "../Header/Sale";
import televizion from "../../../resources/images/televizion.png";
import {Footer} from "../Body/footer";

export const Category = () => {

    const showhide = () => {

        if (document.getElementById('Categories-block_header__dropdown-content_id').style.display === 'block') {
            document.getElementById('Categories-block_header__dropdown-content_id').style.display = 'none';
        } else {
            document.getElementById('Categories-block_header__dropdown-content_id').style.display = 'block';
        }

    }
    const showhide2 = () => {

        if (document.getElementById('Categories-block_header__dropdown-content_id2').style.display === 'block') {
            document.getElementById('Categories-block_header__dropdown-content_id2').style.display = 'none';
        } else {
            document.getElementById('Categories-block_header__dropdown-content_id2').style.display = 'block';
        }

    }
    const showhide3 = () => {

        if (document.getElementById('Categories-block_header__dropdown-content_id3').style.display === 'block') {
            document.getElementById('Categories-block_header__dropdown-content_id3').style.display = 'none';
        } else {
            document.getElementById('Categories-block_header__dropdown-content_id3').style.display = 'block';
        }

    }
    const showhide4 = () => {

        if (document.getElementById('Categories-block_header__dropdown-content_id4').style.display === 'block') {
            document.getElementById('Categories-block_header__dropdown-content_id4').style.display = 'none';
        } else {
            document.getElementById('Categories-block_header__dropdown-content_id4').style.display = 'block';
        }

    }

    return (
        <div>
            <Menu/>
            <div className="container savatcha category">
                <div className="savatcha-header__routesLink mt-2">
                    <span className="savatcha-header__Link mr-2">
                        <Link to={"/"} className="savatcha-header__HomePageLink">Bosh sahifa</Link>
                    </span>
                    <span className="mr-2">
                        <i className="fa fa-angle-right" color="#9d9d9d"></i>
                    </span>
                    <span className="disabled savatcha-header__Link">
                        <Link to="/savat" className="savatcha-header__SavatchaLink">Savatcha</Link>
                    </span>
                </div>
                <h1 className="">Maishiy texnikalar</h1>
                <div className="row mt-4">
                    <div className="col-3">
                        <div className="Filters-block_header">
                            <div className="Filters-block_header_p__filters">
                                <p className="my-3 mx-3">Filtrlar</p>
                            </div>
                            <div className="Categories-block_header">
                                <div className="Categories-block_header__dropdown w-100">
                                    <div className="row m-2 mb-3 m-0" onClick={showhide}>
                                        <span
                                            className=" col-6 d-inline-block Categories-block_header__dropdown_spanCategory text-left">Kategoriyalar</span>
                                        <span className=" col-6 d-inline-block text-right"><i
                                            className="fa fa-angle-down"></i></span>
                                    </div>
                                    <div className="Categories-block_header__dropdown-content"
                                         id="Categories-block_header__dropdown-content_id">
                                        <div className="mx-4 my-1">
                                            <Link className="Categories-block_header__dropdown-content_Link">
                                                KetmonCorporation
                                            </Link>
                                        </div>
                                        <div className="mx-4 my-1">
                                            <Link className="Categories-block_header__dropdown-content_Link">
                                                KetmonCorporation
                                            </Link>
                                        </div>
                                        <div className="mx-4 my-1">
                                            <Link className="Categories-block_header__dropdown-content_Link">
                                                KetmonCorporation
                                            </Link>
                                        </div>
                                        <div className="mx-4 my-1">
                                            <Link className="Categories-block_header__dropdown-content_Link">
                                                KetmonCorporation
                                            </Link>
                                        </div>
                                        <div className="mx-4 my-1">
                                            <Link className="Categories-block_header__dropdown-content_Link">
                                                KetmonCorporation
                                            </Link>
                                        </div>
                                        <div className="mx-4 my-1">
                                            <Link className="Categories-block_header__dropdown-content_Link">
                                                KetmonCorporation
                                            </Link>
                                        </div>
                                        <div className="mx-4 my-1">
                                            <Link className="Categories-block_header__dropdown-content_Link">
                                                KetmonCorporation
                                            </Link>
                                        </div>
                                        <div className="mx-4 my-1">
                                            <Link className="Categories-block_header__dropdown-content_Link">
                                                KetmonCorporation
                                            </Link>
                                        </div>
                                        <div className="mx-4 my-1">
                                            <Link className="Categories-block_header__dropdown-content_Link">
                                                KetmonCorporation
                                            </Link>
                                        </div>
                                        <div className="mx-4 my-1">
                                            <Link className="Categories-block_header__dropdown-content_Link">
                                                KetmonCorporation
                                            </Link>
                                        </div>
                                        <div className="mx-4 my-1">
                                            <Link className="Categories-block_header__dropdown-content_Link">
                                                KetmonCorporation
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="Categories-block_header">
                                <div className="Categories-block_header__dropdown w-100">
                                    <div className="row m-2 mb-3 m-0" onClick={showhide2}>
                                        <span
                                            className=" col-6 d-inline-block Categories-block_header__dropdown_spanCategory text-left">Rang</span>
                                        <span className=" col-6 d-inline-block text-right"><i
                                            className="fa fa-angle-down"></i></span>
                                    </div>
                                    <div className="Categories-block_header__dropdown-content mb-3 mx-4 my-1"
                                         id="Categories-block_header__dropdown-content_id2">
                                        <div
                                            className="Categories-block_header__dropdown-content__color d-inline-block mx-1"></div>
                                        <div
                                            className="Categories-block_header__dropdown-content__color d-inline-block mx-1"></div>
                                        <div
                                            className="Categories-block_header__dropdown-content__color d-inline-block mx-1"></div>
                                        <div
                                            className="Categories-block_header__dropdown-content__color d-inline-block mx-1"></div>
                                        <div
                                            className="Categories-block_header__dropdown-content__color d-inline-block mx-1"></div>
                                        <div
                                            className="Categories-block_header__dropdown-content__color d-inline-block mx-1"></div>
                                        <div
                                            className="Categories-block_header__dropdown-content__color d-inline-block mx-1"></div>
                                        <div
                                            className="Categories-block_header__dropdown-content__color d-inline-block mx-1"></div>
                                        <div
                                            className="Categories-block_header__dropdown-content__color d-inline-block mx-1"></div>
                                    </div>
                                </div>
                            </div>
                            <div className="Categories-block_header">
                                <div className="Categories-block_header__dropdown w-100">
                                    <div className="row m-2 mb-3 m-0" onClick={showhide3}>
                                        <span
                                            className=" col-6 d-inline-block Categories-block_header__dropdown_spanCategory text-left">Rang</span>
                                        <span className=" col-6 d-inline-block text-right"><i className="fa fa-angle-down"></i></span>
                                    </div>
                                    <div className="Categories-block_header__dropdown-content mb-3 mx-4 my-1"
                                         id="Categories-block_header__dropdown-content_id3">
                                        <div className="Categories-block_header__dropdown-content d-inline-block mx-1">

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="Categories-block_header">
                                <div className="Categories-block_header__dropdown w-100">
                                    <div className="row m-2 mb-3 m-0" onClick={showhide4}>
                                        <span
                                            className=" col-6 d-inline-block Categories-block_header__dropdown_spanCategory text-left">Brandlar</span>
                                        <span className=" col-6 d-inline-block text-right"><i
                                            className="fa fa-angle-down"></i></span>
                                    </div>
                                    <div className="Categories-block_header__dropdown-content mx-4 my-1"
                                         id="Categories-block_header__dropdown-content_id4">
                                        <div>
                                            <input type="checkbox" id="defaultCheck" name="example2" className="mr-2"/>
                                            <label htmlFor="defaultCheck" className="m-0">KetmonCorporation</label>
                                        </div>
                                        <div>
                                            <input type="checkbox" id="defaultCheck2" name="example2" className="mr-2"/>
                                            <label htmlFor="defaultCheck2" className="m-0">KetmonCorporation</label>
                                        </div>
                                        <div>
                                            <input type="checkbox" id="defaultCheck3" name="example2" className="mr-2"/>
                                            <label htmlFor="defaultCheck3" className="m-0">KetmonCorporation</label>
                                        </div>
                                        <div>
                                            <input type="checkbox" id="defaultCheck4" name="example2" className="mr-2"/>
                                            <label htmlFor="defaultCheck4" className="m-0">KetmonCorporation</label>
                                        </div>
                                        <div>
                                            <input type="checkbox" id="defaultCheck5" name="example2" className="mr-2"/>
                                            <label htmlFor="defaultCheck5" className="m-0">KetmonCorporation</label>
                                        </div>
                                        <div>
                                            <input type="checkbox" id="defaultCheck6" name="example2" className="mr-2"/>
                                            <label htmlFor="defaultCheck6" className="m-0">KetmonCorporation</label>
                                        </div>
                                        <div>
                                            <input type="checkbox" id="defaultCheck7" name="example2" className="mr-2"/>
                                            <label htmlFor="defaultCheck7" className="m-0">KetmonCorporation</label>
                                        </div>
                                        <div>
                                            <input type="checkbox" id="defaultCheck8" name="example2" className="mr-2"/>
                                            <label htmlFor="defaultCheck8" className="m-0">KetmonCorporation</label>
                                        </div>
                                        <div>
                                            <input type="checkbox" id="defaultCheck9" name="example2" className="mr-2"/>
                                            <label htmlFor="defaultCheck9" className="m-0">KetmonCorporation</label>
                                        </div>
                                        <div>
                                            <input type="checkbox" id="defaultCheck10" name="example2"
                                                   className="mr-2"/>
                                            <label htmlFor="defaultCheck10" className="m-0">KetmonCorporation</label>
                                        </div>
                                        <div>
                                            <input type="checkbox" id="defaultCheck11" name="example2"
                                                   className="mr-2"/>
                                            <label htmlFor="defaultCheck11" className="m-0">KetmonCorporation</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="ml-4 my-4">
                                <button className="btn Categories-block_header_dropdown_button">
                                    O'chirish
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="col-9">
                        <div className="row mb-3">
                            <div className="col-4 test123456">
                                <Sale
                                    ImgUrl="https://wp.toko.uz/wp-content/uploads/2020/11/53_g051sz003.000.574549.vr059.6.50-300x300.jpg"
                                    ProductName="La Lavande"
                                    ProductInfo="Гейзер для ванн Мята"
                                    NewPrice="376 000 сум"
                                    OldPrice="537 000 сум"
                                />
                            </div>
                            <div className={"col-4 test123456"}>
                                <Sale
                                    ImgUrl="https://wp.toko.uz/wp-content/uploads/2020/11/53_g051sz003.000.574549.vr059.6.50-300x300.jpg"
                                    ProductName="La Lavande"
                                    ProductInfo="Гейзер для ванн Мята"
                                    NewPrice="376 000 сум"
                                    OldPrice="537 000 сум"
                                />
                            </div>
                            <div className={"col-4 test123456"}>
                                <Sale
                                    ImgUrl="https://wp.toko.uz/wp-content/uploads/2020/11/53_g051sz003.000.574549.vr059.6.50-300x300.jpg"
                                    ProductName="La Lavande"
                                    ProductInfo="Гейзер для ванн Мята"
                                    NewPrice="376 000 сум"
                                    OldPrice="537 000 сум"
                                />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-4 test123456">
                                <Sale
                                    ImgUrl="https://wp.toko.uz/wp-content/uploads/2020/11/53_g051sz003.000.574549.vr059.6.50-300x300.jpg"
                                    ProductName="La Lavande"
                                    ProductInfo="Гейзер для ванн Мята"
                                    NewPrice="376 000 сум"
                                    OldPrice="537 000 сум"
                                />
                            </div>
                            <div className="col-4 test123456">
                                <Sale
                                    ImgUrl="https://wp.toko.uz/wp-content/uploads/2020/11/53_g051sz003.000.574549.vr059.6.50-300x300.jpg"
                                    ProductName="La Lavande"
                                    ProductInfo="Гейзер для ванн Мята"
                                    NewPrice="376 000 сум"
                                    OldPrice="537 000 сум"
                                />
                            </div>
                            <div className="col-4 test123456">
                                <Sale
                                    ImgUrl="https://wp.toko.uz/wp-content/uploads/2020/11/53_g051sz003.000.574549.vr059.6.50-300x300.jpg"
                                    ProductName="La Lavande"
                                    ProductInfo="Гейзер для ванн Мята"
                                    NewPrice="376 000 сум"
                                    OldPrice="537 000 сум"
                                />
                            </div>
                        </div>
                        <div className="row mb-5">
                            <div className="col-4 test123456">
                                <Sale
                                    ImgUrl="https://wp.toko.uz/wp-content/uploads/2020/11/53_g051sz003.000.574549.vr059.6.50-300x300.jpg"
                                    ProductName="La Lavande"
                                    ProductInfo="Гейзер для ванн Мята"
                                    NewPrice="376 000 сум"
                                    OldPrice="537 000 сум"
                                />
                            </div>
                            <div className="col-4 test123456">
                                <Sale
                                    ImgUrl="https://wp.toko.uz/wp-content/uploads/2020/11/53_g051sz003.000.574549.vr059.6.50-300x300.jpg"
                                    ProductName="La Lavande"
                                    ProductInfo="Гейзер для ванн Мята"
                                    NewPrice="376 000 сум"
                                    OldPrice="537 000 сум"
                                />
                            </div>
                            <div className="col-4 test123456">
                                <Sale
                                    ImgUrl="https://wp.toko.uz/wp-content/uploads/2020/11/53_g051sz003.000.574549.vr059.6.50-300x300.jpg"
                                    ProductName="La Lavande"
                                    ProductInfo="Гейзер для ванн Мята"
                                    NewPrice="376 000 сум"
                                    OldPrice="537 000 сум"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

    <Footer/>
</div>
)
}